module.exports = __webpack_public_path__ + "CH.png?051b276657e12cad676ab83315d9dfd0";